import { usePage } from "@inertiajs/react";
import ProductPropertyHorizontalFilter from "~/components/products/ProductPropertyHorizontalFilter.jsx";
import { Button } from "~/components/ui/button.jsx";
import { ArrowDownUp, Search, SlidersHorizontal } from "lucide-react";
import HorizontalPriceFilter from "@/components/products/HorizontalPriceFilter.jsx";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area.jsx";
import Filters from "@/pages/products/filters/Filters.jsx";
import SheetFilters from "@/components/products/SheetFilters.jsx";
import FilterHandler from "@/lib/products/filter";
import TaxonsHorizontalFilter from "./TaxonsHorizontalFilter";
import { allowedProductPropertiesFilters } from "../../lib/utils";
import Sorting from "./Sorting";
import HorizontalSorting from "./HorizontalSorting";

export default function () {
  const props = usePage().props;
  const { filters, taxon } = props;

  const product_properties_filters = allowedProductPropertiesFilters(
    taxon,
    filters.product_properties
  );
  const filterHandler = new FilterHandler();

  return (
    <div className="space-x-2 flex overflow-hidden items-center">
      {/*<Button variant={'ghost'} className="text-xl"><SlidersHorizontal size={30}/> </Button>*/}
      <div className="flex-none">
        <SheetFilters />
      </div>
      <div className="flex-none">
        <HorizontalSorting />
      </div>
      <div className="hidden">
        <Button variant={"ghost"} className="text-xl_">
          <Search />
          {/* Поиск */}
        </Button>
      </div>

      <ScrollArea className="flex flex-1 overflow-hidden ">
        <div className="flex w-max space-x-2">
          <HorizontalPriceFilter
            onValuesChange={(values) => {
              filterHandler.applyPriceFilter(values);
              filterHandler.navigate();
            }}
          />
          {taxon.display_children_taxons_filter && (
            <TaxonsHorizontalFilter
              taxons={taxon.children}
              onValuesChange={(values) => {
                filterHandler.applyTaxonsFilter(values);
                filterHandler.navigate();
              }}
            />
          )}
          {product_properties_filters.map((productPropertyFilter) => {
            const handelPropertyFilterChange = (values) => {
              const filterKey = `filter[properties][${productPropertyFilter.name}]`;
              filterHandler.applyProductPropertyFilter(filterKey, values);
              filterHandler.navigate();
            };

            return (
              <ProductPropertyHorizontalFilter
                productPropertyFilter={productPropertyFilter}
                onValuesChange={handelPropertyFilterChange}
              />
            );
          })}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
